import { render, staticRenderFns } from "./WarningLayout.vue?vue&type=template&id=1b312ec0&scoped=true"
import script from "./WarningLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WarningLayout.vue?vue&type=style&index=0&id=1b312ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b312ec0",
  null
  
)

export default component.exports